import { useMemo } from 'react';

import { usePageEventByQuery } from 'queries/events/usePageEventByQuery';
import { mapPageEventToDatalayer } from 'services/datalayer/utils';

export const useEventBundle = () => {
  const { event } = usePageEventByQuery();

  const eventBundle = useMemo(() => mapPageEventToDatalayer(event), [event]);

  return eventBundle;
};
